export {}

const layoutAds = document.querySelectorAll<HTMLElement>(".layout-ad-container")

layoutAds.forEach((ad) => {
  const main = ad.closest("main")
  const singleAd = ad.querySelector<HTMLElement>(".i-ad-space")

  if (!main || !singleAd) return

  const isElementOutsideMainBottom = () => {
    const adRect = singleAd.getBoundingClientRect()
    const mainRect = main.getBoundingClientRect()

    ad.classList.toggle("--fixed-bottom", adRect.bottom + 40 > mainRect.bottom && !(adRect.bottom > window.innerHeight))
  }

  window.addEventListener("scroll", isElementOutsideMainBottom, true)
})
